import React, {Fragment, useEffect, useState} from "react";
import {
    CurrencyFormatter, PercentFormatter, ProductColumn,
    ProductName,
    UnitFormatter
} from "../../../../utils/formatters";
import TextInput from "../../../form/TextInput";
import {ifCompletedInput, operation} from "../../../../utils/other";
import Select from "../../../form/Select";
import OperationListStock from "../../OperationList/OperationListStock";
import {Tooltip} from "react-tippy";
import CheckBox from "../../../form/CheckBox";
import debounce from "lodash-es/debounce";
import Icon from "../../../form/Icon";
import {loadComponent} from "../../../../utils/components";
import DataGrid from "src/components/form/SelectorGrid/DataGrid";
import ProductDisplayNameProps from "src/utils/DataGrid/Fields/ProductDisplayNameProps";
import FieldData from "src/components/form/SelectorGrid/DataGrids/Table/FieldData";
import classNames from "classnames";
import set from "src/utils/set";
import {calculateItemPrice, PAYMENT_PRICE_TYPE_UNIT_GROSS_PRICE} from "src/components/classes/Price";
import BigNumber from "bignumber.js";
import Confirm, {smallDeleteProps} from "src/components/form/Confirm";
import SelectorGrid from "src/components/form/SelectorGrid/SelectorGrid";
import {get} from "src/utils/dotutils";
import Modal from "src/components/layout/Modal";
import Portal from "src/components/layout/Portal";
import Button from "src/components/form/Button";
import AbortablePromise from "../../../../utils/promise/AbortablePromise";
import {ComponentConfigType} from "../../../../utils/ComponentConfigType";
import {DataGridUnitConvertComponent, UnitConvertComponent} from "../../../classes/Unit";

const filterable = true;
const sortable = true;

//region DisplayFields

//region DiscountedProducts

let loadedDiscounts: object[] = [];

function removeDuplicates(myArr: object[], prop: string) {
    return myArr.filter((obj, pos, arr) => {
        // @ts-ignore
        return arr.map(mapObj => mapObj[prop]).indexOf(obj[prop]) === pos;
    });
}

const DiscountedProducts = ({operationitem_id}: {operationitem_id: string}) => {
    const [discounts, setDiscounts] = useState([]);
    const [discountTypes, setDiscountTypes] = useState([]);
    useEffect(() => {
        let request: AbortablePromise<any>;
        setDiscounts([]);
        setDiscountTypes([]);
        if (operationitem_id) {
            request = loadComponent("componentlist", {
                component: "DiscountedProduct",
                itemsperpage: 0,
                filter: {field: "operationitem_id", value: operationitem_id}
            });
            request.then((res: any) => {
                setDiscountTypes(res.items);
                if (res.items.length) {
                    const loadedDiscountIds = loadedDiscounts.map(({id}: {id: string}) => id);
                    let allIds = res.items.map(({discount_id}: {discount_id: string}) => discount_id);
                    let ids = res.items.filter(({discount_id}: {discount_id: string}) => loadedDiscountIds.indexOf(discount_id) === -1).map(({discount_id}: {discount_id: string}) => discount_id);
                    if (ids.length) {
                        request = loadComponent("componentlist", {
                            component: "Discount",
                            itemsperpage: 0,
                            filter: {field: "id", value: ids, operator: "in"}
                        });
                        request.then((res: any) => {
                            loadedDiscounts = removeDuplicates([...loadedDiscounts, ...res.items], "id");
                            setDiscounts(loadedDiscounts.filter(({id}: {id: string}) => allIds.indexOf(id) !== -1));
                        });
                    } else {
                        setDiscounts(loadedDiscounts.filter(({id}: {id: string}) => allIds.indexOf(id) !== -1));
                    }
                }
            });
        }
        return () => {
            request?.abort();
        }
    }, [operationitem_id]);
    return !!(discounts || []).filter((discount) => discount.type !== "basediscount").length && <Icon
        lib="fas"
        name="tag"
        tooltip={{position: "bottom", html: <Fragment>
                <div>Felhasznált kedvezmények:</div>
                {discountTypes.map((discountType, idx) => {
                    const discount = discounts.find(({id}) => discountType.discount_id + "" === "" + id);
                    if (discount.type === "basediscount") {
                        return null;
                    }
                    return <div key={idx}>
                        {discount.name}
                        {" "}
                        (-{discount.value} {((calculation_mode) => {
                        switch (calculation_mode) {
                            case "percentage":
                                return "%";
                            case "fix_discount":
                            case "fix_price":
                                return "Ft"
                            default:
                                return calculation_mode;
                        }
                    })(discount.calculation_mode)}) ({discountType.discount_direction > 0 ? "Cél termék" : "Feltétel termék"})
                    </div>;
                })}
            </Fragment>}}
    />;
}

//endregion DiscountedProducts

//region Download

const Download = ({physical, purcahse_item_id}: {physical: string, purcahse_item_id: string}) => {
    let request: AbortablePromise<any>;
    const [downloads, setDowloads] = useState(null);
    useEffect(() => {
        setDowloads(null);

        if (Number(physical || '0') === 0) {
            request = loadComponent("Download", {
                itemsperpage: 0,
                filter: [{field: "component_type", value: "purchaseitem"},
                    {field: "component_id", value: purcahse_item_id}]
            });
            request.then((res: any) => {
                setDowloads(res?.qty || null);
            });
        }
        return () => {
            request && request.abort();
        }
    }, [purcahse_item_id]);
    return downloads !== null && <Icon
        lib="fa"
        name="download"
        tooltip={{position: "bottom", html: <Fragment>
                <div>{"Letöltések száma: " + String(downloads)}</div>
            </Fragment>}}
    />;
}

//endregion Download

//endregion DisplayFields

//region items field editors

const fieldalias: {[key: string]: string} = {
    "netsaleprice": "saleprice_net",
    "totalprice": "saleprice_gross_total",
}
const fieldsavealias: {[key: string]: string} = {
    "netsaleprice": "saleprice",
    "discount": "saleprice",
    "totalprice": "saleprice",
}
const convert = (value: RevertItem): Item => {
    Object.keys(fieldalias).forEach((key) => {
        // @ts-ignore
        value[fieldalias[key]] = value[key];
    });
    // @ts-ignore
    return value;
}
const revert = (value: Item): RevertItem => {
    Object.keys(fieldalias).forEach((key) => {
        // @ts-ignore
        value[key] = value[fieldalias[key]];
    });
    // @ts-ignore
    return value;
}

type RevertItem = {
    vat: object,
    netsaleprice: number,
    totalprice: number,
    discount: number,
}

type Item = {
    vat: object,
    saleprice: number,
    listprice: number,
    discount: number,
}

const setPrice = ({editItems, value, field, row, rowKey, componentListFieldConfig}: {
    editItems: (items: any) => void,
    value: any,
    field: string,
    row: RevertItem,
    rowKey: string,
    componentListFieldConfig: ComponentConfigType
}): RevertItem => {
    const originField = field;
    field = fieldalias[field] || field;
    let oldItem = convert({...row});
    let newItem = convert({...row});
    set(newItem, field, value);
    if (!oldItem.vat) {
        oldItem = {...newItem};
    }
    if (newItem.vat) {
        const saleprice = calculateItemPrice("saleprice", field, newItem, oldItem, PAYMENT_PRICE_TYPE_UNIT_GROSS_PRICE);
        saleprice.setPrice(newItem.saleprice);
        const listprice = calculateItemPrice("listprice", field, newItem, oldItem, PAYMENT_PRICE_TYPE_UNIT_GROSS_PRICE);
        listprice.setPrice(newItem.listprice);

        if (field === "discount") {
            saleprice.setPrice(new BigNumber(listprice.getPrice()).minus(new BigNumber(listprice.getPrice()).dividedBy(100).multipliedBy(newItem.discount).toNumber()));
        } else {
            newItem.discount = Number(new BigNumber(100).minus(new BigNumber(saleprice.getPrice()).dividedBy(listprice.getPrice()).multipliedBy(100)).toNumber().toFixed(2));
        }

        saleprice.boundTo(newItem, "saleprice");
        listprice.boundTo(newItem, "listprice");
        newItem.saleprice = saleprice.getPrice();
        newItem.listprice = listprice.getPrice();
    }
    let changed = false;
    if (JSON.stringify(oldItem) !== JSON.stringify(newItem)) {
        changed = true;
    }
    if (editItems && changed) {
        editItems({
            [rowKey]: {
                // @ts-ignore
                [componentListFieldConfig.idfield]: newItem[componentListFieldConfig.idfield],
                // @ts-ignore
                [fieldsavealias[originField] || originField]: newItem[fieldsavealias[originField] || originField]
            }
        });
    }
    return revert(newItem);
}

const ProductNameComponent = ProductName("product_id");

class DisplayNameFieldComponent extends FieldData<any, any> {
    getFormatter() {
        const formatters = super.getFormatter();
        if (!this.props.isAggregation) {
            return [...formatters, <Fragment>
                <DiscountedProducts operationitem_id={this.props.row.operationitem_id}/>
                <Download physical={this.props.row.category.physical} purcahse_item_id={this.props.row.id}/>
            </Fragment>];
        } else {
            return formatters;
        }
    }
}

class PriceFieldComponent extends FieldData<any, any> {
    getFormatter() {
        const formatters = super.getFormatter();
        if (!formatters.length) {
            return [CurrencyFormatter(this.props.value)];
        }
        return formatters;
    }

    getEditor() {
        if (this.props.editableFields.indexOf(this.props.name + "." + this.props.field) === -1) return [];
        const editors = super.getEditor();
        if (this.props.field !== "listprice" && !editors.length) {
            return [
                <TextInput
                    type="decimal"
                    name={this.props.field}
                    label={false}
                    focus
                    value={this.props.value}
                    onKeyDown={(e, field, value) => {
                        if (ifCompletedInput(e)) {
                            setPrice({...this.props, value});
                        }
                    }}
                    onBlur={(e, field, value) => {
                        setPrice({...this.props, value});
                    }}
                />
            ];
        } else {
            return editors;
        }
    }

    layout(props: any, state: any) {
        if (props.className instanceof Function) {
            props = {...props};
            props.className = classNames(props.className(props), "currency");
        } else {
            props = {...props};
            props.className = classNames(props.className, "currency");
        }
        return super.layout(props, state);
    }
}

class VatrateFieldComponent extends FieldData<any, any> {
    getFormatter() {
        const formatters = super.getFormatter();
        if (!formatters.length) {
            return [<span className="vat">{this.props.value.name}</span>];
        }
        return formatters;
    }

    getEditor() {
        if (this.props.editableFields.indexOf(this.props.name + "." + this.props.field) === -1) return [];
        const editors = super.getEditor();
        if (!editors.length) {
            return [
                <Select
                    name={this.props.field}
                    component="vatrate"
                    filter={{field: "active", value: 1}}
                    objectValue={true}
                    label={false}
                    storeType="local"
                    value={this.props.value}
                    view={["rate"]}
                    saveChanges={(field, value) => {
                        setPrice({...this.props, value});
                    }}
                />
            ];
        } else {
            return editors;
        }
    }

    layout(props: any, state: any) {
        if (props.className instanceof Function) {
            props = {...props};
            props.className = classNames(props.className(props), "vat");
        } else {
            props = {...props};
            props.className = classNames(props.className, "vat");
        }
        return super.layout(props, state);
    }
}

class DiscountFieldComponent extends FieldData<any, any> {
    getFormatter() {
        const formatters = super.getFormatter();
        if (!formatters.length) {
            return [PercentFormatter(this.props.value)];
        }
        return formatters;
    }

    getEditor() {
        if (this.props.editableFields.indexOf(this.props.name + "." + this.props.field) === -1) return [];
        const editors = super.getEditor();
        if (!editors.length) {
            return [
                <TextInput
                    type="decimal"
                    name={this.props.field}
                    label={false}
                    focus
                    value={this.props.value}
                    onKeyDown={(e, field, value) => {
                        if (ifCompletedInput(e)) {
                            setPrice({...this.props, value});
                        }
                    }}
                    onBlur={(e, field, value) => {
                        setPrice({...this.props, value});
                    }}
                />
            ];
        } else {
            return editors;
        }
    }

    layout(props: any, state: any) {
        if (props.className instanceof Function) {
            props = {...props};
            props.className = classNames(props.className(props), "discount");
        } else {
            props = {...props};
            props.className = classNames(props.className, "discount");
        }
        return super.layout(props, state);
    }
}

class QtyFieldComponent extends FieldData<any, any> {
    getFormatter() {
        const formatters = super.getFormatter();
        if (!formatters.length) {
            return [<UnitConvertComponent value={this.props.value ?? 0} unit={this.props.row.unit} />];
        }
        return formatters;
    }

    getEditor() {
        if (this.props.editableFields.indexOf(this.props.name + "." + this.props.field) === -1) return [];
        const editors = super.getEditor();
        if (!editors.length) {
            return [
                <TextInput
                    type="number"
                    name={this.props.field}
                    label={false}
                    focus
                    value={this.props.value}
                    onKeyDown={(e, field, value) => {
                        value = parseInt(value || "0");
                        let oldvalue = parseInt(this.props.value || "0");
                        if (oldvalue !== value) {
                            if (this.props.editableFields.indexOf(this.props.name + "." + "id") === -1 && value <= 0) {
                                return;
                            }
                            if (ifCompletedInput(e)) {
                                if (value === 0) {
                                    this.removeItems({[this.props.rowKey]: this.props.row});
                                } else {
                                    setPrice({...this.props, value});
                                }
                            }
                        }
                    }}
                    onBlur={(e, field, value) => {
                        value = parseInt(value || "0");
                        let oldvalue = parseInt(this.props.value || "0");
                        if (oldvalue !== value) {
                            if (this.props.editableFields.indexOf(this.props.name + "." + "id") === -1 && value <= 0) {
                                return;
                            }
                            if (value === 0) {
                                this.removeItems({[this.props.rowKey]: this.props.row});
                            } else {
                                setPrice({...this.props, value});
                            }
                        }
                    }}
                />
            ];
        } else {
            return editors;
        }
    }

    layout(props: any, state: any) {
        if (props.className instanceof Function) {
            props = {...props};
            props.className = classNames(props.className(props), "unit");
        } else {
            props = {...props};
            props.className = classNames(props.className, "unit");
        }
        return super.layout(props, state);
    }
}

//endregion items field editors

//region additem

class AddItemModal extends React.Component<any, any> {

    state: {
        opened: boolean,
        itemsToAdd: any[]
    } = {
        opened: false,
        itemsToAdd: []
    };

    render() {
        return <Fragment>
            <Portal>
                <Modal
                    state={this.state.opened}
                    size="large"
                    header="Termékek"
                    disabled={this.props.disabled || this.props.isLoading}
                    buttons={[
                        {
                            text: "Mégse",
                            props: {
                                color: "default",
                                disabled: this.props.disabled || this.props.isLoading
                            },
                            onClose: true,
                            onClick: async () => {
                                try {
                                    this.setState({itemsToAdd: [], opened: false});
                                } catch (e) {

                                }
                            }
                        },
                        {
                            text: "Hozzáadás",
                            props: {
                                color: "primary",
                                disabled: !this.state.itemsToAdd.length || this.props.disabled || this.props.isLoading
                            },
                            onClick: async () => {
                                try {
                                    if (this.state.itemsToAdd.length) {
                                        const items = this.state.itemsToAdd.map((item) => {
                                            item = {...item};
                                            item.product_id = item.id;
                                            item.saleprice = item.saleprice !== undefined ? item.saleprice : item.listprice;
                                            item.qty = item.qty || 1;
                                            delete item.id;
                                            delete item.category;
                                            delete item.vat;
                                            return item;
                                        });
                                        await this.props.addItems(items);
                                    }
                                    this.setState({itemsToAdd: [], opened: false});
                                } catch (e) {

                                }
                            }
                        }
                    ]}
                >
                    <SelectorGrid
                        component="product"
                        onItemUpdate={async (item, oldItem, field) => {
                            if (parseInt(item.qty) > 0) {
                                if (field === "discount") {
                                    item.discount = parseFloat(item.discount);
                                }
                                if (field === "saleprice") {
                                    item.saleprice = parseFloat(item.saleprice);
                                    item.discount = (100 - item.saleprice / item.listprice * 100).toFixed(2);
                                }
                                if (field === "discount") {
                                    item.saleprice = item.listprice - Math.round(item.listprice / 100 * item.discount);
                                }
                                let has = false;
                                const itemsToAdd = this.state.itemsToAdd.map((_item) => {
                                    if (_item.id + "" === item.id) {
                                        has = true;
                                        return item;
                                    } else {
                                        return _item;
                                    }
                                });
                                if (!has) {
                                    itemsToAdd.push(item);
                                }
                                this.setState({itemsToAdd: itemsToAdd.sort((a, b) => a.qty - b.qty)});
                            } else {
                                const itemsToAdd = this.state.itemsToAdd.filter((_item) => {
                                    return _item.id + "" !== item.id;
                                });
                                this.setState({itemsToAdd: itemsToAdd.sort((a, b) => a.qty - b.qty)});
                                delete item.qty;
                            }
                            return item;
                        }}
                        onSort={(field, direction) => {
                            if (field === "qty" && !!this.state.itemsToAdd.length) {
                                return {
                                    expression: "FIELD({{id}}, " + this.state.itemsToAdd.map((item) => item.id).join(", ") + ")",
                                    direction
                                };
                            }
                        }}
                        view={["vat","category.physical"]}
                        columns={{
                            "displayname": {
                                ...ProductColumn("product_id"),
                                width: 6,
                            },
                            "category.name": {
                                header: 'Árutípus',
                                width: 1,
                                sortable,
                                filterable
                            },
                            "sku": {
                                header: 'ISBN',
                                width: 2,
                                sortable,
                                filterable
                            },
                            "barcode": {
                                header: 'Vonalkód',
                                width: 1,
                                sortable,
                                filterable
                            },
                            "listprice": {
                                header: 'Fogyasztói ár',
                                width: 2,
                                sortable,
                                filterable,
                                renderer: CurrencyFormatter,
                                className: "currency"
                            },
                            "qty": {
                                header: 'Db',
                                width: 1,
                                sortable,
                                renderer: (value, row) => UnitFormatter((this.state.itemsToAdd.find((item) => row.id + "" === "" + item.id) || {}).qty, row.unit),
                                className: "unit",
                                editor:
                                    (parent) =>
                                        (props, value) =>
                                            <TextInput type="number" name="qty" label={false} focus
                                                       value={(this.state.itemsToAdd.find((item) => props.rowData.id + "" === "" + item.id) || {}).qty}
                                                       onKeyDown={(e, field, value) => {
                                                           ifCompletedInput(e) && parent.onEditorValueChange(props, value);
                                                       }}
                                                       onBlur={(e, field, value) => parent.onEditorValueChange(props, value)}/>
                            },
                            ...(this.props.pos ? {
                                "stock": {
                                    header: 'Készlet',
                                    renderer: (value, row) => {
                                        return <OperationListStock productId={get(row, "product_id")} product={row}>
                                            <a className="btn btn-block btn-default btn-xs">
                                                Készlet
                                            </a>
                                        </OperationListStock>;
                                    }
                                }
                            }: {})
                        }}
                    />
                </Modal>
            </Portal>
            <Button
                size="xs"
                color="primary"
                onClick={() => this.setState({opened: true})}
                icon={{lib: "fa", name: "plus"}}
            />
        </Fragment>
    }
}

//endregion additem

export default class Items extends React.Component<any, {missingFilter: boolean, hoverColumnValue: null|string}> {

    state = {
        missingFilter: false,
        hoverColumnValue: null,
    }

    constructor(props: any) {
        super(props);
    }

    hoverDebounce = debounce((value: string) => {
        this.setState({hoverColumnValue: value});
    }, 300)

    componentDidUpdate(prevProps: any, prevState: any, snapshot: any) {
        if (this.props.values.state !== prevProps.values.state || this.props.values.id !== prevProps.values.id) {
            this.setState({
                missingFilter: false
            });
        }
    }

    render() {
        if (!this.props.values[this.props.componentConfig.idfield]) {
            return null;
        }
        let editableFields = [...this.props.editableFields];
        if (editableFields.indexOf("items.qty") !== -1) {
            editableFields.push("items.id");
        }
        /*if (this.props.stateType.Modification(this.props.values.state)) {
            editableFields = ["id", "netsaleprice", "saleprice", "totalprice", "discount", "qty", "vat"];
        } else if (operation([this.props.stateConst.PurchasePriceModification, this.props.stateConst.Correctional], this.props.values.state, "includes")) {
            editableFields = ["netsaleprice", "saleprice", "totalprice", "discount", "vat", "qty"];
        }
        if (this.props.stateType.Correctional(this.props.values.state)) {
            editableFields.push("id");
        }
        if (parseInt(this.props.values.modifying)) {
            editableFields = ["id", "netsaleprice", "saleprice", "totalprice", "discount", "vat", "qty"];
        }*/
        const isUnderMissingStockState = this.props.stateType.StockReserved(this.props.values.state, "<");
        const isStrict = !!this.props.values.strict;
        return (
            <DataGrid
                {...this.props.getFieldProps("items")}
                ref={(el) => this.items = el}
                name="items"
                editableFields={editableFields}
                className={"p-small-table " + this.props.componentConfig.componentname + " items"}
                view={["id", "operationitem_id", "category.physical", "category.composite", "base_product_id", "name", "qty", "unit", "listprice", "saleprice", "totalprice", "sku", "barcode", "product_id", "vat", "strict_reserved", "reserved", "mismatch"]}
                filter={this.state.missingFilter ? (!isStrict ? {field: "mismatch", value: 0, operator: "!="} : {fields: ["qty","strict_reserved"], operator: "!="}): undefined}
                paginationRight={(props) => {
                    return <Fragment>
                        {isUnderMissingStockState && <Tooltip title={!this.state.missingFilter ? "Csak a készlethiányosakat mutasd" : "Mindent mutat"}><CheckBox
                            onIcon={{lib: "fa", name: "box"}}
                            offIcon={{lib: "fa", name: "box-open"}}
                            value={1}
                            checked={this.state.missingFilter}
                            label={false}
                            saveChanges={(field, value) => {
                                this.setState({missingFilter: !!value});
                            }}
                            {...props}
                        /></Tooltip>}
                    </Fragment>
                }}
                addItems={(items) => {
                    return items.map((item) => {
                        item[this.props.componentConfig.componentname] = this.props.values[this.props.componentConfig.idfield];
                        return item;
                    });
                }}
                editItems={(items, props) => {
                    return items.map((editedItem) => {
                        let item = {};
                        Object.keys(props.componentListFieldConfig.fielddefs).forEach((key) => {
                            if (editedItem[key] !== undefined) {
                                item[key] = editedItem[key];
                            }
                        })
                        return item;
                    });
                }}
                fields={{
                    ...(editableFields.indexOf("items.id") !== -1 ? {
                        "actions": {
                            props: {
                                header: (props) => <AddItemModal {...props} />,
                                label: false,
                                width: "auto",
                                pos: this.props.values.pos,
                                formatter: ({removeItems, row, rowIndex}) => {
                                    return <Confirm
                                        {...smallDeleteProps}
                                        onAccept={() => {
                                            removeItems({[rowIndex]: row});
                                        }}
                                    />
                                }
                            }
                        }
                    } : {}),
                    "displayname": {
                        type: DisplayNameFieldComponent,
                        props: {
                            ...ProductDisplayNameProps("product_id"),
                        }
                    },
                    "category.name": {
                        props: {
                            header: 'Árutípus',
                            width: 1,
                            sortable,
                            filterable
                        }
                    },
                    "sku": {
                        props: {
                            header: 'ISBN',
                            width: 1,
                            sortable,
                            filterable
                        }
                    },
                    "barcode": {
                        props: {
                            header: 'Vonalkód',
                            width: 1,
                            sortable,
                            filterable
                        }
                    },
                    "listprice": {
                        type: PriceFieldComponent,
                        props: {
                            header: 'Fogyasztói ár',
                            width: 1,
                            sortable,
                            filterable,
                        }
                    },
                    ...(this.props.componentConfig.componentname === "purchase"? {
                        "discount": {
                            type: DiscountFieldComponent,
                            props: {
                                header: 'Kedvezmény',
                                width: 1,
                                sortable,
                                filterable,
                            }
                        },
                        "netsaleprice": {
                            type: PriceFieldComponent,
                            props: {
                                header: 'Nettó e.ár',
                                width: 1,
                                sortable,
                                filterable,
                            }
                        },
                        "vat": {
                            type: VatrateFieldComponent,
                            props: {
                                header: "Áfa",
                                width: "vat",
                                sortable,
                                //filterable: componentFilter({component: "vatrate"}),
                            }
                        },
                        "saleprice": {
                            type: PriceFieldComponent,
                            props: {
                                header: 'Bruttó e.ár',
                                width: 1,
                                sortable,
                                filterable,
                            }
                        },
                    }: {}),
                    "qty": {
                        type: QtyFieldComponent,
                        props: {
                            header: 'Db',
                            filterOperator: '=',
                            aggregation: {
                                type: 'SUM',
                            },
                            width: 1,
                            sortable,
                            filterable,
                            className: (props) => ({
                                base_product: true,
                                [!props.isAggregation && this.state.hoverColumnValue + "" === "" + props.row.base_product_id ? "same" : ""]: true
                            }),
                            ...(isUnderMissingStockState ? {
                                onMouseOver: ({row, isAggregation}) => {
                                    !isAggregation && this.hoverDebounce && this.hoverDebounce(row.base_product_id);
                                },
                                onMouseLeave: () => {
                                    this.hoverDebounce && this.hoverDebounce(null);
                                },
                                tooltip: (props) => {
                                    return !props.isAggregation && isUnderMissingStockState && parseInt(props.row.mismatch || 0) !== 0 ? (props.row.mismatch + " db Készlethiány!") : "";
                                },
                                className: (props) => ({
                                    "bold color": !props.isAggregation && isUnderMissingStockState && parseInt(props.row.mismatch || 0) !== 0,
                                    [!props.isAggregation && (parseInt(props.row.mismatch || 0) !== 0 ? (isStrict ? "danger" : "warning") : "success")]: isUnderMissingStockState,
                                    base_product: true,
                                    [!props.isAggregation && this.state.hoverColumnValue + "" === "" + props.row.base_product_id ? "base_product same" : ""]: true
                                }),
                            } : {})
                        }
                    },
                    ...(isUnderMissingStockState && this.props.values?.pos ? {
                        "qty_action": {
                            props: {
                                header: ' ',
                                label: false,
                                width: 1,
                                formatter: ({row}) => {
                                    return <OperationListStock productId={row?.product_id} product={row}>
                                        <a className="btn btn-block btn-default btn-xs">
                                            Készlet
                                        </a>
                                    </OperationListStock>;
                                }
                            }
                        }
                    } : {}),
                    ...(this.props.componentConfig.componentname === "purchase"? {
                        "totalprice": {
                            type: PriceFieldComponent,
                            props: {
                                header: 'Bruttó érték',
                                width: 1,
                                aggregation: {
                                    type: 'SUM',
                                },
                                sortable,
                                filterable,
                            }
                        },
                    }: {}),
                    ...(["410", "420"].indexOf(this.props.values.state + "") !== -1 ? {
                        "receivedqty": {
                            props: {
                                header: 'Beérkezett',
                                width: 1,
                                sortable,
                                filterable,
                                className: ({row}) => ({
                                    "unit": true,
                                    "danger color": (parseInt(row.receivedqty || 0) - parseInt(row.qty || 0)) < 0,
                                    "warning color": (parseInt(row.receivedqty || 0) - parseInt(row.qty || 0)) > 0,
                                }),
                                formatter: DataGridUnitConvertComponent,
                            }
                        },
                    } : {}),
                    ...(isUnderMissingStockState ? {
                        "strict_reserved": {
                            props: {
                                header: 'Lefoglalva',
                                filterOperator: '=',
                                sortable,
                                filterable,
                                formatter: DataGridUnitConvertComponent,
                                onMouseOver: ({row, isAggregation}) => {
                                    !isAggregation && this.hoverDebounce && this.hoverDebounce(row.base_product_id);
                                },
                                onMouseLeave: () => {
                                    this.hoverDebounce && this.hoverDebounce(null);
                                },
                                tooltip: (props) => {
                                    return !props.isAggregation && isUnderMissingStockState && parseInt(props.row.mismatch || 0) !== 0 ? (props.row.mismatch + " db Készlethiány!") : "";
                                },
                                className: (props) => ({
                                    "unit strict_reserved": true,
                                    "bold color": !props.isAggregation && isUnderMissingStockState && parseInt(props.row.mismatch || 0) !== 0,
                                    [!props.isAggregation && (parseInt(props.row.mismatch || 0) !== 0 ? (isStrict ? "danger" : "warning") : "success")]: isUnderMissingStockState,
                                    base_product: true,
                                    [!props.isAggregation && this.state.hoverColumnValue + "" === "" + props.row.base_product_id ? "same" : ""]: true
                                }),
                            }
                        },
                        ...(!isStrict ? {
                            "reserved": {
                                props: {
                                    header: 'összesen',
                                    filterOperator: '=',
                                    sortable,
                                    filterable,
                                    formatter: DataGridUnitConvertComponent,
                                    onMouseOver: ({row, isAggregation}) => {
                                        !isAggregation && this.hoverDebounce && this.hoverDebounce(row.base_product_id);
                                    },
                                    onMouseLeave: () => {
                                        this.hoverDebounce && this.hoverDebounce(null);
                                    },
                                    tooltip: (props) => {
                                        return !props.isAggregation && isUnderMissingStockState && parseInt(props.row.mismatch || 0) !== 0 ? (props.row.mismatch + " db Készlethiány!") : "";
                                    },
                                    className: (props) => ({
                                        "unit text-left reserved": true,
                                        "bold color": !props.isAggregation && isUnderMissingStockState && parseInt(props.row.mismatch || 0) !== 0,
                                        [!props.isAggregation && (parseInt(props.row.mismatch || 0) !== 0 ? (isStrict ? "danger" : "warning") : "success")]: isUnderMissingStockState,
                                        base_product: true,
                                        [!props.isAggregation && this.state.hoverColumnValue + "" === "" + props.row.base_product_id ? "base_product same" : ""]: true
                                    }),
                                }
                            },
                        } : {}),
                        "instock": {
                            props: {
                                header: 'Készlet',
                                filterOperator: '=',
                                sortable,
                                filterable,
                                formatter: DataGridUnitConvertComponent,
                                className: "unit"
                            }
                        }
                    } : {})
                }}
                data={this.props.values}
                orderBy={{field: "name", direction: "ASC"}}
                componentConfig={this.props.componentConfig}
            />
        );
    }
}